export default "__VITE_ASSET__nHfgWhEp__"